import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useMemo } from 'react';
import { preventDefault, useCallbacks } from 'shared/hooks/utils';
import { ObserveControl } from './types';
import { noop } from 'ts-essentials';
import { useBooleanState } from 'shared/hooks/state/boolean';
export const ObserveControlProvider = memo(function ObserveControlProvider(props) {
    const { children, drag_controls, onClose } = props;
    const [control_disabled, enableControl, disableControl] = useBooleanState(false);
    const [disabled_modal_interaction, enableModalInteraction, disableModalInteraction,] = useBooleanState(false);
    const correctDisableControl = useCallbacks([preventDefault, disableControl]);
    const onCloseModal = onClose ?? noop;
    const value = useMemo(() => ({
        disabled_modal_interaction,
        disableModalInteraction,
        enableModalInteraction,
        control_disabled,
        enableControl,
        disableControl: correctDisableControl,
        drag_controls,
        onClose: onCloseModal,
    }), [
        disabled_modal_interaction,
        disableModalInteraction,
        enableModalInteraction,
        control_disabled,
        disableControl,
        disableControl,
        drag_controls,
        onCloseModal,
    ]);
    return _jsx(ObserveControl.Provider, { value: value, children: children });
});
export const useObserveControl = () => useContext(ObserveControl);
